import type { IGridStyle } from '@vedalib/editor'
import { css } from 'styled-components'

import { applyGrid } from '../formControls/Grid/utils'
import { applySize } from '../formControls/Size/utils'
import type { INodeV2StyledProps } from './NodeV2Styled'

const Group = (style: IGridStyle | null) => css`
  grid-auto-rows: ${applySize(style?.gridAutoRows)};
`

const Base = (style: IGridStyle | null) => css`
  grid-template-rows: ${applyGrid(style?.gridRows)};
`

const GridStyled = ({ $node, $style }: INodeV2StyledProps) => css`
  display: grid;

  grid-template-columns: ${applyGrid($style?.gridColumns)};
  ${$node.repeatable ? Group($style) : Base($style)}

  grid-column-gap: ${$style?.gridColumnsGap || 0}px;
  grid-row-gap: ${$style?.gridRowsGap || 0}px;
`

export default GridStyled
